module.exports = __webpack_public_path__ + "static/img/anzhidinglan.141c35e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/anzhidinglan.png
// module id = Pn9h
// module chunks = 1